import React from 'react';
import classNames from 'classnames';
import Immutable from 'immutable';

import './style.scss';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Button } from '../../../components';

const ParagraphText = ({ entity, className }) => {

  const classes = classNames('Paragraph ParagraphText', className);
  const title = entity.getIn(['field_title', 0, 'value']);
  const body = entity.getIn(['field_text', 0, 'processed']);
  const linkTitle = entity.getIn(['field_link', 0, 'title']);
  const link = entity.getIn(['field_link', 0], Immutable.Map());
  const href = link.get('alias') ? link.get('alias') : link.get('uri');

  return (
    <div className={classes}>
      <h2 className="ParagraphText__title">{title}</h2>
      <WysiwygField
        property="schema:text"
        className="ParagraphText__text"
        html={body}
      />
      {href && linkTitle && <Button secondary key={href} href={href}>{linkTitle}</Button>}
    </div>
  );
};

export default ParagraphText;
